type Props = {
  currentPage: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

export function MarketplacePagination({
  currentPage,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
}: Props) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total ? (currentPage - 1) * pageSize + 1 : 0;
  const end = Math.min(currentPage * pageSize, total);
  return (
    <footer className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-border-t tw-border-slate-200 tw-px-4 tw-py-3 dark:tw-border-slate-700 sm:tw-px-6">
      <p className="tw-text-sm tw-text-slate-600 dark:tw-text-slate-300">
        {total
          ? `Showing ${start}-${end} of ${total}`
          : "No marketplace accounts"}
      </p>
      <div className="tw-flex tw-items-center tw-gap-2">
        <div className="tw-relative tw-w-24 tw-shrink-0">
          <select
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            className="tw-h-9 tw-w-full tw-appearance-none tw-rounded-md tw-border tw-border-slate-300 tw-bg-white tw-px-2 tw-pr-7 tw-text-sm tw-leading-none dark:tw-border-slate-600 dark:tw-bg-slate-800"
          >
            <option value={10}>10 rows</option>
            <option value={20}>20 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>
        <button
          type="button"
          aria-label="Previous page"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-300 disabled:tw-cursor-not-allowed disabled:tw-opacity-40 dark:tw-border-slate-600"
        >
          <span className="material-symbols-outlined tw-inline-flex tw-items-center tw-leading-none">
            chevron_left
          </span>
        </button>
        <span className="tw-inline-flex tw-min-w-14 tw-items-center tw-justify-center tw-text-center tw-text-sm tw-leading-none">
          {currentPage} / {totalPages}
        </span>
        <button
          type="button"
          aria-label="Next page"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-300 disabled:tw-cursor-not-allowed disabled:tw-opacity-40 dark:tw-border-slate-600"
        >
          <span className="material-symbols-outlined tw-inline-flex tw-items-center tw-leading-none">
            chevron_right
          </span>
        </button>
      </div>
    </footer>
  );
}
